import moment from "moment";
import FoldableOption from "../../../Roles/General/Notificatioins/Modal/FoldableOption";
import InformationOption from "../../../Roles/General/Notificatioins/Modal/InforamationOption";
import {formatDate} from "../../../utils/utils";
import HistoryOption from "../../../Roles/General/Notificatioins/Modal/HistoryOption";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import React from "react";
import StyledNotificationsModal from "../../../Roles/General/Notificatioins/Modal/NotificationModal.styled";

type NotificationModalBooking = {
    className?: string,
    isOpen?: boolean,
    deleteModal?: any,
    data?: {
        ticketId?: string,
        status?: string,
        createdAt?: string,
        info?: {
            organization?: string,
            date?: any,
            type?: string,
            amount?: any,
            address?: string,
            contactsPhone: string
        }
    },
    button?: any
}

function NotificationModalBooking(props: any) {
    const data = props.data
    return (
        <Modal onOutsideClick={() => {
        }}>
            <StyledNotificationsModal open={props.isOpen} className={props.className}>
                <div className='top'>
                    <div className='header'>
                        <div className='back' onClick={_=> props.deleteModal(props?.data?.status)}>
                            <i className='fas fa-arrow-left'/>
                        </div>
                        <div className='name'>Заявка на выезд</div>
                        <div className='close'></div>
                    </div>
                    <div className='content'>
                        <div className='content-info'>
                            <div className="status">
                                <b>Статус:</b>
                            </div>
                            <div className="date">
                                <b>Обращение:</b>
                                {moment(data?.created_at).format("YYYY-MM-DD HH:mm")}
                            </div>
                        </div>
                        <div className="list">
                            <FoldableOption isOpen={true} title={"Тикет обращения:"}>
                                #{data?.ticket_id}
                            </FoldableOption>
                            <FoldableOption isOpen={true} title={"Тип обращения:"}>
                                {data?.info?.type}
                            </FoldableOption>
                            <FoldableOption isOpen={true} title={"Информация:"}>
                                <InformationOption type="Организация" prev={data?.info?.organization || "Не указано"}
                                                   next={""}/>
                                <InformationOption type="Даты"
                                                   prev={props?.data?.info?.date ? props?.data?.info?.date : "Не указано"}
                                                   next={""}/>
                                <InformationOption type="Количество людей" prev={data?.info?.amount || "Не указано"}
                                                   next={""}/>

                                <InformationOption type="Адрес" prev={data?.info?.address || "Не указано"}
                                                   next={""}/>
                            </FoldableOption>

                        </div>
                    </div>
                    <div className="bottom">
                        <div className='buttons'>
                            {props?.button(props?.data?.status, props?.data?._id)?.map(button => <Button {...button}/>)}
                        </div>
                    </div>

                </div>
            </StyledNotificationsModal>

        </Modal>
    )
}


export default NotificationModalBooking